'use strict';

const Enum = require('./enum');
const LocksConstants = require('./locks');

/**
 * Defines rule access types
 *
 * @enum
 * @readonly
 */
const GroupTypes = Object.create(Enum, {
  DualLocks: { value: 'dualLocks', enumerable: true },
});

const GroupAllowedEventTypes = Object.create(Enum, {
  DualLocks: {
    value: [LocksConstants.LockActions.LOCK, LocksConstants.LockActions.UNLOCK, LocksConstants.LockActions.SECURE],
    enumerable: true,
  },
});

module.exports = { GroupTypes, GroupAllowedEventTypes };
